module.exports = "data:image/webp;base64,UklGRlYAAABXRUJQVlA4IEoAAAAQBACdASo8ADwAPpFAm0mlo6KhKggAsBIJaQAATXHevipWpcRfV5r6YAD++M7stOD3/5tb/6BIgUylHU+V12+HLOiYCmlxUcAAAA=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10019-color.webp
// module id = v/oK
// module chunks = 14